// extracted by mini-css-extract-plugin
export default {"wrap":"TagFilter_wrap__q8TdU","label":"TagFilter_label__AU99h","select":"TagFilter_select__kkLfd"};